class a extends Map {
  constructor(t) {
    super();
    this.factory = t;
  }
  get(t) {
    let e = super.get(t);
    return e === void 0 && (e = this.factory(t), this.set(t, e)), e;
  }
}
export { a as DefaultMap };